// extracted by mini-css-extract-plugin
module.exports =  {"description":"ChahgMPITS6QlpG3S0rC","disabled":"jNfTK95aD_8rAd2MzVMf"};